<template>
  <div class="bulk-charge-details-display">
    <div class="row">
      <div class="col-md-6">
        <h4>Charge Details</h4>
        <div class="alert alert-danger" v-if="bulkCharge.failed">
          This payment was declined. No funds were taken from your card.
        </div>
        <div class="list-group-item">
          <template v-for="charge in bulkCharge.charges">
            <div class="row">
              <div class="col-xs-3 col-sm-4 col-md-5">
                <p><strong>{{ charge.name }}</strong></p>
              </div>
              <div class="col-xs-9 col-sm-8 col-md-7">
                <p>${{ charge.cost }}</p>
              </div>
            </div>
          </template>
          <div class="row">
            <hr/>
            <div class="col-xs-3 col-sm-4 col-md-5">
              <p><strong>Total</strong></p>
            </div>
            <div class="col-xs-9 col-sm-8 col-md-7">
              <p>${{ bulkCharge.cost }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkChargeDisplay',
  data () {
    return {
      bulkCharge: {
        charges: []
      }
    }
  },
  route: {
    data () {
      this.refreshData()
    }
  },
  methods: {
    refreshData () {
      let params = this.$route.params
      let authType = this.$route.authType
      this.$http.get(`${authType}/bulk-charge`, { params }).then(({ data }, status, request) => {
        this.bulkCharge = data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BulkChargeDisplay.vue?ef0ef042